import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getRejectedDocuments } from 'services/VerificationService'
import { TEN_MINUTES } from 'utils/utils'

export const useRejectedDocumentsQuery = (isEnabled = true) => {
  return useQuery(reactQueryKeys.rejectedDocuments(), getRejectedDocuments, {
    staleTime: TEN_MINUTES,
    enabled: isEnabled,
    onError: (error: unknown) => {
      logSentryError('Error: useRejectedDocumentsQuery', error, {
        isEnabled,
        refetchInterval: TEN_MINUTES,
      })
    },
  })
}
